import { render, staticRenderFns } from "./MyGroups.vue?vue&type=template&id=6018993b&scoped=true&"
import script from "./MyGroups.vue?vue&type=script&lang=js&"
export * from "./MyGroups.vue?vue&type=script&lang=js&"
import style0 from "./MyGroups.vue?vue&type=style&index=0&id=6018993b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018993b",
  null
  
)

export default component.exports